import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from "react-helmet-async";
import HeaderFour from '../../components/Header/HeaderFour';
import FooterTwo from '../../components/Footer/FooterTwo';
import Breadcrumb from '../../components/Breadcrumb';

import Logo from '../../assets/img/logo/logo-white-2.png';
import aboutImg1 from '../../assets/img/about/credo.jpg';
import aboutImg2 from '../../assets/img/about/credo2.png';


const Credo = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };
  
  return (
    <main>
    <Helmet>
      <title>Our Credo & Values | CBS HUB Private Limited Central Books Hyderabad</title>
      <meta name="description" content="Discover the core values and credo that have guided CBS HUB (Central Books) for 75+ years — integrity, education-first, and service to 450+ schools and 9 million+ students." />
      <meta name="keywords" content="CBS HUB credo, Central Books values, education company mission Hyderabad, school supply company values India" />
      <link rel="canonical" href="https://www.centralbooks.in/credo" />
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content="Our Credo & Values | CBS HUB Private Limited Central Books Hyderabad" />
      <meta property="og:description" content="Discover the core values and credo that have guided CBS HUB (Central Books) for 75+ years — integrity, education-first, and service to 450+ schools and 9 million+ students." />
      <meta property="og:url" content="https://www.centralbooks.in/credo" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.centralbooks.in/images/credo-og.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Our Credo & Values | CBS HUB Private Limited Central Books Hyderabad" />
      <meta name="twitter:description" content="Discover the core values and credo that have guided CBS HUB (Central Books) for 75+ years — integrity, education-first, and service to 450+ schools and 9 million+ students." />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.centralbooks.in/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Credo",
              "item": "https://www.centralbooks.in/credo"
            }
          ]
        })}
      </script>
    </Helmet>
    <HeaderFour />
    <Breadcrumb title="Our Credo — The Values That Define CBS HUB for 75+ Years" subTitle="Credo" />
    <div className="it-wrok-area it-wrok-bg ed-work-style-2 pt-120 pb-90 grey-bg-4">
    <div className="container">
      <div className="row justify-content-center text-center mb-50">
        <div className="col-xl-10">
          <h2 className="pb-20">Education-First: Our Commitment to Schools and Students</h2>
          <h3 className="pb-30" style={{ color: '#ea580c', fontSize: '1.6rem', fontWeight: '600' }}>Integrity and Trust in Every Institutional Partnership</h3>
          <p className="lead" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#374151' }}>
            CBS HUB Private Limited has been guided by one credo for over 75 years: education first. Our values of integrity, reliability and service have made us the trusted B2B school supply partner for 450+ institutions serving 9 million+ students across India.
          </p>
        </div>
      </div>
      <div className="row">
        <div
          className="col-xl-12 col-lg-12 col-md-12 mb-30 wow animate__fadeInUp"
          data-wow-duration=".9s"
          data-wow-delay=".3s"
        >
          <img src={aboutImg1} alt="" />
          <img src={aboutImg2} alt="" />
        </div>
      </div>
    </div>
  </div>
    <FooterTwo
      footerClass="it-footer-area it-footer-bg it-footer-style-5 ed-footer-style-5 inner-style black-bg pb-70"
      footerLogo={Logo}
      btnClass="it-btn-white sky-bg"
      copyrightTextClass="it-copyright-text inner-style text-center"
    />
  </main>
  );
};
export default Credo;
